import React, { useState, useEffect } from 'react'
import { Info, X, Monitor, Calculator, ShieldAlert, ChevronRight } from 'lucide-react'

const DisclaimerPopup: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true)

  const handleAccept = () => {
    setIsOpen(false)
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto relative flex flex-col md:flex-row overflow-hidden animate-in zoom-in-95 duration-300">
        
        {/* Przycisk zamknięcia */}
        <button 
          onClick={handleAccept}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors z-10"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Lewa strona - Obrazek (Opcjonalnie) */}
        <div className="hidden md:block md:w-5/12 bg-gray-100 relative">
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-0"></div>
          {/* Placeholder na obrazek laptopa z konfiguratorem */}
          <div className="w-full h-full min-h-[400px] flex items-center justify-center bg-[#E8E9EC] p-8">
            <div className="w-full aspect-square max-w-[280px] bg-white rounded-xl shadow-lg border border-gray-200 flex flex-col items-center justify-center p-6 text-center space-y-4 relative z-10">
              <Monitor className="w-16 h-16 text-red-500" />
              <div className="text-gray-400 font-medium uppercase tracking-widest text-sm">Konfigurator 3D</div>
              <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
                <div className="w-1/3 h-full bg-red-500"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Prawa strona - Treść */}
        <div className="w-full md:w-7/12 p-8 md:p-10 flex flex-col justify-center">
          
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-red-200">
              <Info className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Ważna <span className="text-red-600">informacja</span>
            </h2>
          </div>

          <div className="space-y-8">
            
            {/* Sekcja 1 */}
            <div className="flex gap-5">
              <div className="w-14 h-14 rounded-full bg-red-50 border border-red-100 flex items-center justify-center flex-shrink-0 text-red-600">
                <Monitor className="w-7 h-7" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Kolory i wizualizacje mają <span className="text-red-600">charakter poglądowy</span></h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Rzeczywisty wygląd, odcień oraz struktura produktów mogą nieznacznie różnić się od prezentowanych na ekranie ze względu na ustawienia urządzenia, parametry wyświetlacza oraz warunki oświetleniowe.
                </p>
              </div>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            {/* Sekcja 2 */}
            <div className="flex gap-5">
              <div className="w-14 h-14 rounded-full bg-red-50 border border-red-100 flex items-center justify-center flex-shrink-0 text-red-600">
                <Calculator className="w-7 h-7" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Wycena ma charakter <span className="text-red-600">orientacyjny</span></h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Wycena wygenerowana przez konfigurator ma charakter orientacyjny i służy wyłącznie celom informacyjnym. Ostateczna cena zostanie przygotowana przez doradcę KOST-BET na podstawie wygenerowanego projektu oraz jego szczegółowej weryfikacji.
                </p>
              </div>
            </div>

          </div>

          {/* Akceptacja */}
          <div className="mt-8 bg-red-50 rounded-xl p-4 flex items-center gap-4">
            <ShieldAlert className="w-6 h-6 text-red-600 flex-shrink-0" />
            <p className="text-sm text-gray-900 font-medium">
              Korzystając z konfiguratora akceptujesz powyższe informacje.
            </p>
          </div>

          {/* Przycisk */}
          <div className="mt-8">
            <button
              onClick={handleAccept}
              className="bg-red-600 hover:bg-red-700 text-white font-medium py-3.5 px-8 rounded-lg flex items-center gap-2 transition-all shadow-md shadow-red-200 hover:shadow-lg hover:shadow-red-300 hover:-translate-y-0.5 active:translate-y-0"
            >
              Rozumiem, przejdź dalej
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>

        </div>
      </div>
    </div>
  )
}

export default DisclaimerPopup
